import React, { useEffect, useState } from "react";
import { Pagination, Typography } from "@mui/material";

import getEventsListAPI from "../../../../api/getEventsListAPI";
import AuctionCard from "../../../components/AuctionCard";

const PAGE_SIZE = 8;

// the signed-in buyer's (added to) or seller's (created) auctions; lotStatus
// decides which come first - live, upcoming or ended
const MyAuctions = ({ lotStatus }) => {
  const [page, setPage] = useState(1);
  const [events, updateEvents] = useState({ apiState: "loading", list: [] });

  useEffect(() => {
    setPage(1);
  }, [lotStatus]);

  useEffect(() => {
    let ignore = false;
    const getMyAuctions = async () => {
      try {
        const { data } = await getEventsListAPI({
          pageSize: PAGE_SIZE,
          page,
          lotStatus,
          mine: true,
        });
        if (!ignore) {
          updateEvents({
            apiState: "success",
            list: data.data,
            totalPages: data.meta?.totalPages ?? 1,
          });
        }
      } catch (error) {
        if (!ignore) updateEvents({ apiState: "error", list: [] });
      }
    };
    getMyAuctions();

    return () => {
      ignore = true;
    };
  }, [page, lotStatus]);

  if (events.apiState === "success" && events.list.length === 0) {
    return (
      <Typography sx={{ textAlign: "center", color: "#7E8184", py: 4 }}>
        You have no auctions yet.
      </Typography>
    );
  }

  return (
    <>
      <div className="row">
        {events.list.map((event) => (
          <AuctionCard key={event.eventId} {...event} />
        ))}
      </div>
      {events.totalPages > 1 && (
        <Pagination
          sx={{ display: "flex", justifyContent: "center", mt: 2 }}
          count={events.totalPages}
          page={page}
          onChange={(event, value) => setPage(value)}
          color="primary"
        />
      )}
    </>
  );
};

export default MyAuctions;
